import { useSearchParams } from 'next/navigation'

/**
 * Where to send the user when they finish or abandon a flow. Pages that want
 * to come back here link in with `returnTo` set to their own path.
 */
export const useReturnPath = ({
  defaultPath,
}: {
  defaultPath: string
}): string => {
  const returnTo = useSearchParams().get('returnTo')
  // Only in-app paths — anything foreign or protocol-relative falls back.
  const isInAppPath =
    !!returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')
  return isInAppPath ? returnTo : defaultPath
}
